import { LearnerAndInviteeResponse, ColourScoreColour } from 'api';

export type TransformedLearnerAndInviteeResponse = LearnerAndInviteeResponse & {
  learnerId: string;
  colourScores?: {
    conscious: Record<ColourScoreColour, number> & {
      preferred: ColourScoreColour[];
    };
  } | null;
};

export const transformLearner = ({
  id,
  organisation,
  ...rest
}: LearnerAndInviteeResponse): TransformedLearnerAndInviteeResponse => ({
  id: `${id}-${organisation.id}`,
  learnerId: id,
  organisation,
  colourScores: rest.colourScores as {
    conscious: Record<ColourScoreColour, number> & {
      preferred: ColourScoreColour[];
    };
  } | null,
  ...rest,
});
